module.exports = __webpack_public_path__ + "static/media/networking.d11c557f.jpg";